import React, { useState, useEffect } from 'react';
import Map from './Map';
import './SchemeDashboard.css';
import SchemeRightSidebar from './SchemeRightSidebar';
import { ButtonContainer } from './Button';
import SchemeSidebar from './SchemeSidebar';
import Cards from '../components/Cards';
import Table from './Table';

const SchemeDashboard = () => {
  const [filters, setFilters] = useState({
    client: '',
    project: '',
    projectType: '',
    serviceType: '',
    scheme: ''
  });

  const [projects, setProjects] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);

  // Fetch data and filter projects based on the selected scheme
  useEffect(() => {
    fetch('/db2_sales.json')
      .then(response => response.json())
      .then(data => {
        if (filters.scheme) {
          const filteredProjects = data.filter(
            project => project.parent_scheme_name === filters.scheme
          );
          setProjects(filteredProjects); // ✅ keep all projects for the scheme
        }
      })
      .catch(error => console.error('Error fetching data:', error));
  }, [filters.scheme]);

  useEffect(() => {
    const fetchLastUpdated = async () => {
      try {
        const response = await fetch('/db2_date&time.json');
        const data = await response.json();
        setLastUpdated(new Date(data.updatedAt).toLocaleString());
      } catch (error) {
        console.error('Error fetching last updated time:', error);
      }
    };

    fetchLastUpdated();
  }, []);

  const handleFilterChange = (filterType, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value
    }));
  };

  return (
    <div className="main-content">
      <Cards />
      <div className="schemeDashboard">
        <SchemeSidebar setFilters={handleFilterChange} />
        <div className="map-container">
          <ButtonContainer />
          <Map filters={filters} />
        </div>
        <div className="right-sidebar">
          {lastUpdated && (
            <div className="last-updated">
              <p>Last updated: {lastUpdated}</p>
            </div>
          )}
          <SchemeRightSidebar projects={projects} />
        </div>
      </div>
      <Table filters={filters} />
    </div>
  );
};

export default SchemeDashboard;
